import React from "react";
import BlogDetail from "../components/blog/blog-detail";
import SidebarBlog from "../components/blog/sidebar-blog";
import Layout from "../components/layout/layout";
import SidebarBlogDetail from "../components/blog/sidebar-blog-detail";

const BlogDetailPage = () => {
  return (
    <>
      <Layout>
        <div class="content">
          <div class="container">
            <div class="row">
              <BlogDetail />

              <SidebarBlogDetail />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default BlogDetailPage;
